
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/transportbil/overlanding",
      function () {
        return require("private-next-pages/tyres/transportbil/overlanding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/transportbil/overlanding"])
      });
    }
  